<template>
  <v-sheet
    class="mx-auto"
    elevation="2"
    max-width="1200"
  >
    <v-container>
      <div class="text-center">
        <h3>Ponte en contacto con nosotros</h3>
        <p mt-0>Te responderemos a la brevedad</p>
      </div>
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >
        <v-row>
          <v-col xs12 sm6 md6>
            <v-text-field
              v-model="name"
              :counter="10"
              :rules="nameRules"
              label="Nombre"
              required
            ></v-text-field>
          </v-col>
          <v-col xs12 sm6 md6>
            <v-text-field
              v-model="email"
              :rules="emailRules"
              label="E-mail"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col xs12 sm6 md6>
            <v-text-field
              v-model="subject"
              :counter="10"
              :rules="subjectRules"
              label="Asunto"
              required
            ></v-text-field>
          </v-col>
          <v-col xs12 sm6 md6>
            <v-text-field
              v-model="phone"
              :rules="phoneRules"
              label="Teléfono"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col xs12 sm12 md12>
            <v-text-field
              v-model="message"
              :counter="10"
              :rules="messageRules"
              label="Mensaje"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col xs12 sm6 md6>
            <v-btn
              :disabled="!valid"
              color="success"
              class="mr-4"
              @click="validate"
            >
              Enviar
            </v-btn>
            <v-btn
              color="error"
              class="mr-4"
              @click="reset"
            >
              Resetablecer
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </v-sheet>
</template>

<script>
export default {
    data: () => ({
      valid: true,
      name: '',
      nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      phone: '',
      subject: '',
      subjectRules: [
        v => !!v || 'Subject is required',
        v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ],
      message: '',
      messageRules: [
        v => !!v || 'Message is required',
        v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ],
    }),

    methods: {
      validate () {
        this.$refs.form.validate()
      },
      reset () {
        this.$refs.form.reset()
      }
    },
  }
</script>

<style>

</style>